import React from 'react';
import { Select } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
const options = [
    {
        label: COPY_GENERIC.ORGANIZE_BY(COPY_SPECIFIC.GROUP),
        value: 'group'
    },
    {
        label: COPY_GENERIC.ORGANIZE_BY(COPY_SPECIFIC.CLASSIFICATION),
        value: 'classification'
    }
];
export const OrganizeBySelect = (props) => React.createElement(Select, Object.assign({}, props, { defaultValue: 'group', options: options }));
